/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifySignIn from "aws-amplify-react/lib/Auth/SignIn";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { SignInFormView } from "./AuthFormViews";

const SignInBase: any = withInlineAuthError(AmplifySignIn);

/** Custom Sign In — Amplify auth logic + DS form + handoff chrome. */
export class SignIn extends SignInBase {
    showComponent() {
        const { hide = [] } = this.props;
        if (hide && hide.includes(SignIn)) {
            return null;
        }

        const usernameLabel = I18n.get(this.getUsernameLabel());

        return (
            <AuthShell title={I18n.get("Sign in to your account")}>
                <SignInFormView
                    defaultUsername={this.state.username}
                    error={this.state.authError}
                    loading={this.state.loading}
                    onFieldChange={this.handleInputChange}
                    onForgotPassword={() => this.changeState("forgotPassword")}
                    onSubmit={this.signIn}
                    usernameLabel={usernameLabel}
                />
            </AuthShell>
        );
    }
}

export default SignIn;
